import styled from 'styled-components';
import { Close } from '@styled-icons/material/Close';

export const ModalContainer = styled.div`
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  width: 391px;
  min-height: 474px;
  height: auto;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1rem;
  z-index: 9999;

  h1.headline-page,
  h2.headline-page,
  h3.headline-session,
  h4.headline-session {
    font-size: 1.5rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.grayDark3};
    margin: 0;
    padding-right: 2rem;
    line-height: 1.3;
  }

  picture.image {
    display: block;
    width: 100%;
    flex: 1;
    min-height: 0;
  }

  picture.image img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  .buttons {
    width: 100%;
  }

  .hefesto-button {
    width: 100% !important;
    height: 48px !important;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.grayDark2};
  z-index: 1;

  &:hover {
    color: ${({ theme }) => theme.colors.grayDark4};
  }
`;

export const CloseIcon = styled(Close)`
  width: 1.25rem;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    position: static;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  p.description {
    font-size: 0.875rem;
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark4};
    margin-bottom: 0;
  }
`;

export const ModalImage = styled.img`
  width: 100%;
  flex: 1;
  min-height: 0;
  object-fit: cover;
`;
